export default __webpack_public_path__ + "static/tablet_sek2_KV05-dfed69108e4e54d128383f041a6f9537.mp4";